@if (!this.loading && !luminaria) {
  <app-breadcrumb
    listado="/main/luminarias/luminarias"
    etiquetaListado="Luminarias"
    [titulo]="luminaria?.identificacion"
  ></app-breadcrumb>
  <app-empty-state
    icon="lightbulb"
    message="No se encontró la luminaria"
  ></app-empty-state>
} @else if (!this.loading) {
  <app-breadcrumb
    listado="/main/luminarias/luminarias"
    etiquetaListado="Luminarias"
    [titulo]="luminaria?.identificacion"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>lightbulb</mat-icon></div>
    <div class="encabezado-texto">
      <h1>{{ luminaria.identificacion }}</h1>
      @if (direccion) {
        <span class="encabezado-nombre">{{ direccion }}</span>
      }
      <div class="encabezado-chips">
        @if (luminaria.dispositivo?.tipo) {
          <span class="chip">
            <mat-icon>category</mat-icon>
            {{ luminaria.dispositivo.tipo }}
          </span>
        }
        @if (luminaria.cliente?.nombre) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ luminaria.cliente.nombre }}
          </span>
        }
        @if (luminaria.estadoOperativo === 'Mantenimiento') {
          <!-- Sin ícono: engineering es el del técnico (docs/ICONOS.md) -->
          <span class="chip estado-advertencia">En mantenimiento</span>
        }
      </div>
    </div>
    <!-- Mismo permiso que pide el listado para editar -->
    @if (puedeEditar) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar luminaria"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-luminaria-info
          [luminaria]="luminaria"
        ></app-detalles-luminaria-info>
      </ng-template>
    </mat-tab>

    <!-- Perfil y comandos: jerarquía de perfiles, aplicación del perfil,
         comandos manuales y métricas de downlinks (antes al final de Info) -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">tune</mat-icon>
        <span>Perfil y comandos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-luminaria-perfil
          [luminaria]="luminaria"
        ></app-detalles-luminaria-perfil>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">description</mat-icon>
        <span>Historial Reportes</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-reportes-genericos
          [entidad]="luminaria"
          tipoEntidad="Luminaria"
          [tipoValoresReporte]="[tipoValoresReportePeriodico]"
        ></app-listado-reportes-genericos>
      </ng-template>
    </mat-tab>

    <!-- Consumo: solo GPE y ACTIS reportan energía -->
    @if (esLuminariaConConsumo) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">bolt</mat-icon>
          <span>Reportes de Consumo</span>
        </ng-template>
        <ng-template matTabContent>
          <app-listado-reportes-genericos
            [entidad]="luminaria"
            tipoEntidad="Luminaria"
            [tipoValoresReporte]="[tipoValoresReporteEnergia]"
          ></app-listado-reportes-genericos>
        </ng-template>
      </mat-tab>
    }

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">report</mat-icon>
        <span>Historial Eventos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-eventos-genericos-historico
          [id]="luminaria._id"
        ></app-eventos-genericos-historico>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">send</mat-icon>
        <span>Historial Comandos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-comandos-historico
          [deveui]="luminaria.dispositivo?.deveui"
          tipo="Luminaria"
        ></app-listado-comandos-historico>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">note</mat-icon>
        <span>Notas</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-notas
          [idAsignado]="luminaria._id"
          [idCliente]="luminaria.idCliente"
          tipo="Nota"
          tipoDispositivo="Luminaria"
        ></app-listado-notas>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">contacts</mat-icon>
        <span>Contactos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-notas
          [idAsignado]="luminaria._id"
          [idCliente]="luminaria.idCliente"
          tipo="Contacto"
          tipoDispositivo="Luminaria"
        ></app-listado-notas>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">build</mat-icon>
        <span>Servicio Técnico</span>
      </ng-template>
      <ng-template matTabContent>
        <app-eventos-tecnicos-genericos
          [id]="luminaria._id"
        ></app-eventos-tecnicos-genericos>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">router</mat-icon>
        <span>Eventos LoRaWAN</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-eventos-lora
          [deveui]="luminaria.dispositivo?.deveui"
        ></app-listado-eventos-lora>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">assignment</mat-icon>
        <span>Asignaciones</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-asignacions
          [idEntidad]="luminaria._id"
          [tipoEntidad]="'modificada'"
        ></app-listado-asignacions>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
} @else {
  <app-detalle-esqueleto
    icono="lightbulb"
    listado="/main/luminarias/luminarias"
    etiquetaListado="Luminarias"
    [pestanas]="11"
  ></app-detalle-esqueleto>
}
